import { Component } from '@angular/core';

@Component({
  selector: 'app-expired',
  templateUrl: './expired.component.html'
})
export class ExpiredComponent {}
